<template>
  <div class="clickLog-box">
    <!--操作栏-->
    <!--
    <div class="statis-box">
      <ul>
        <li v-for="(item, i) in tags" :key="i" @click="getType(item.value)" :class="index === i ? 'active' : ''">{{item.name}}</li>
      </ul>
    </div>
    -->
    <div class="action-bar">
      <el-input placeholder="请输入用户ID" size="small" clearable class="param-input" v-model="params.uid"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getClickLog('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="createdAt" label="添加时间" align="center" fixed min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="aid" label="广告ID" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.aid || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户UUID" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import { changeTime } from '@/utils/global'
import API from '@/api'
export default {
  data() {
    return {
      // 排序下拉数据
      tags: [
        {
          name: '昨日',
          value: 1
        },
        {
          name: '今日',
          value: 2
        },
        {
          name: '本周',
          value: 3
        },
        {
          name: '本月',
          value: 4
        },
        {
          name: '总',
          value: 5
        },
      ],
      time: '',
      index: 0,
      // 列表数据
      tableData: [],
      loading: false,
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        uid: ''
      }
    }
  },
  created() {
    this.getClickLog()
  },
  methods: {
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0])
        this.params.end = changeTime(time[1])
      } else {
        this.params.start = ''
        this.params.end = ''
      }
      this.getClickLog('status')
    },
    // 请求订单列表
    getClickLog(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getClickLog(this.params).then(res => {
        if (res.code === 200 && res.data.logs) {
          this.tableData = res.data.logs
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getClickLog()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getClickLog()
    },
    getType(value) {
      this.params.type = value
      this.getClickLog('status')
    }
  },
}
</script>
<style lang="scss">
.clickLog-box {
  .statis-box {
    width: 100%;
    height: 30px;
    margin-bottom: 15px;
    line-height: 35px;
    font-size: 14px;
    color: #999;
    span {
      margin-right: 20px;
    }
    .first-data {
      margin-left: 50px;
    }
    li {
      width: 65px;
      height: 30px;
      border-radius: 4px;
      background: #e63765;
      color: white;
      cursor: pointer;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
      float: left;
      margin-right: 15px;
      &:hover {
        background: #eb5f84;
      }
    }
    .active {
      background: #eb5f84;
    }
  }
}
</style>
